import { Component } from '@angular/core';

@Component({
  selector: 'tad-data-sources',
  templateUrl: './data-sources.component.html',
  styleUrls: ['./data-sources.component.scss']
})
export class DataSourcesComponent {}
